import useSWR from 'swr';
import { getPhSettings } from '@/features/auth-management/model/ph-auth-api';

const usePhSettings = () => {
  const { data, error, isLoading } = useSWR(
    'ph-settings',
    getPhSettings,
    {
      dedupingInterval: 5000,
      errorRetryCount: 1,
      shouldRetryOnError: false,
    }
  );

  return {
    registerFlow: data?.registerFlow ?? 'short',
    outlet: data?.outlet ?? [],
    crypto: data?.crypto,
    fillOut: data?.fillOut,
    isLoading,
    error,
  };
};

export { usePhSettings };
